<template>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex mb-1 xs12>
            <h2>Reserved Room {{room_allocation.allocation}}</h2>
      </v-flex>
      <v-flex mb-1 xs6 v-for="attendee in room_allocation.attendees" :key="attendee.id">
        <v-layout row wrap class='room_attendee assigned'>
            <v-flex xs2 style='margin: auto 0'><v-icon :color="gender_color(attendee.gender)">fas fa-{{ gender_icon(attendee.gender) }}</v-icon> </v-flex>
            <v-flex xs10 style='margin: auto 0; padding-left: 0.5em; padding-right: 0.5em' text-xs-left>{{attendee.nickname}} / {{attendee.full_name}} / {{attendee.native_name}}</v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-1 xs6 v-for="i in (room_allocation.capacity - room_allocation.attendees.length)" :key="i">
        <v-layout row wrap class='room_attendee available'>
            <v-flex xs2 style='margin: auto 0'><v-icon>fas fa-user</v-icon> </v-flex>
            <v-flex xs10 style='margin: auto 0; padding-left: 0.5em; padding-right: 0.5em' text-xs-left>비어있음<br/>Available</v-flex>
        </v-layout>
      </v-flex>

      <RoomAddMember :room_allocation="room_allocation" v-if="space_available"/>
      <v-flex xs12 mb-4 v-if="!space_available">
        <b style='color: red;'>Room Full</b>
      </v-flex>
      <RoomDelMember :room_allocation="room_allocation" :attendees="attendees" v-if="space_used"/>
    </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import RoomAddMember from './RoomAddMember';
import RoomDelMember from './RoomDelMember';

export default {
  components: {RoomAddMember, RoomDelMember},
  props: ['room_allocation'],
  data: () => ({
    ready: false,
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (value.length >= 2 && value.length < 32) || 'At least 2 characters',
    },
    finished: false,
  }),
  beforeMount: async function() {},
  computed: {
    ...mapState(['myprofile', 'events', 'attendees', 'event_teams']),
    space_used() {
      return this.room_allocation.attendees.length > 0;
    },
    space_available() {
      return (
        this.room_allocation.capacity - this.room_allocation.attendees.length >
        0
      );
    },
    attendees() {
      return this.room_allocation.attendees;
    },
  },
  watch: {},
  methods: {
    confirm() {},
    gender_color(gender) {
      if (gender == 'M') {
        return 'blue';
      } else if (gender == 'F') {
        return 'pink';
      } else return '';
    },
    gender_icon(gender) {
      if (gender == 'M') {
        return 'male';
      } else if (gender == 'F') {
        return 'female';
      } else return 'user';
    },
  },
};
</script>

<style scoped>
.room_attendee {
  min-height: 50px;
  border-radius: 5px;
  margin: 2px;
}
.room_attendee.available {
  background: #dfd;
}
.room_attendee.assigned {
  background: #eee;
}
</style>
